import { Form, Formik } from 'formik';
import { useState } from 'react';
import { FaLock } from 'react-icons/fa';
import { MdEdit } from 'react-icons/md';
import { toast } from 'react-toastify';
import { useTheme } from 'styled-components';

import settingsApi from '../../../APIs/settings';
import mail from '../../../assets/icons/Mail.svg';
import phone from '../../../assets/icons/phone.svg';
import User from '../../../assets/icons/User.svg';
import escConstants from '../../../constants';
import { useRoot } from '../../../context/RootProvider';
import {
  Button,
  FormContainer,
  Input,
  Typography,
} from '../../../designComponents';
import { requestAPI } from '../../../utils';
import { PersonalInformationWrapper } from './style';

const PersonalInformation = () => {
  const theme = useTheme();
  const { auth, updateAuth } = useRoot();
  console.log(auth, 'auth');
  const [loading, setLoading] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [initialValues, _setInitialValues] = useState({
    user: auth?.role,
    name: auth?.fullName,
    email: auth?.emailAddress,
    number: auth?.contactInfo?.phoneNumber,
  });

  const handlePersonalInfoUpdate = async (values: any) => {
    try {
      setLoading(true);
      const updatedData = await requestAPI(
        settingsApi.updatePersonalInfo({
          fullName: values.name,
          contactInfo: {
            phoneNumber: values.number,
          },
        }),
      );
      setLoading(false);
      toast(escConstants.toastMessages.updatePersonalInformation);
      setEditMode(false);
      if (updatedData) {
        console.log(updatedData, 'dataupdated');
        updateAuth({ ...updatedData });
      }
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const handleEdit = () => {
    setEditMode((prev) => !prev);
  };
  return (
    <PersonalInformationWrapper>
      <div className="heading">
        <Typography
          className="setting-title"
          size={14}
          strong
          style={{ marginBottom: '10px' }}
        >
          Personal Information
        </Typography>
        {!editMode && <MdEdit className="btn-edit" onClick={handleEdit} />}
      </div>
      <Formik
        initialValues={initialValues}
        onSubmit={handlePersonalInfoUpdate}
        enableReinitialize
      >
        {({ values, setFieldValue, handleSubmit }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <FormContainer label="User Type" marginBottom="20px">
                <Input
                  name="user"
                  value={values.user}
                  onChange={(e) => setFieldValue('user', e.target.value)}
                  iconLeft={<img src={User} alt="user icon" />}
                  readOnly
                  disabled
                  iconRight={<FaLock />}
                  containerStyle={{
                    borderColor: !editMode
                      ? theme.colors.disable
                      : theme.colors.border,
                  }}
                />
              </FormContainer>
              <FormContainer label="Full Name" marginBottom="20px">
                <Input
                  name="name"
                  value={values.name}
                  onChange={(e) => setFieldValue('name', e.target.value)}
                  iconLeft={<img src={User} alt="user icon" />}
                  readOnly={!editMode}
                  style={{ opacity: editMode ? '1' : '0.5' }}
                  disabled={!editMode}
                  containerStyle={{
                    borderColor: !editMode
                      ? theme.colors.disable
                      : theme.colors.border,
                  }}
                />
              </FormContainer>
              <FormContainer label="Email Address" marginBottom="20px">
                <Input
                  name="email"
                  value={values.email}
                  onChange={(e) => setFieldValue('email', e.target.value)}
                  iconLeft={<img src={mail} alt="mail icon" />}
                  readOnly
                  disabled
                  iconRight={<FaLock />}
                  containerStyle={{
                    borderColor: !editMode
                      ? theme.colors.disable
                      : theme.colors.border,
                  }}
                />
              </FormContainer>

              <FormContainer label="Mobile Number" marginBottom="20px">
                <Input
                  name="number"
                  value={values.number || ''}
                  onChange={(e) => setFieldValue('number', e.target.value)}
                  iconLeft={<img src={phone} alt="phone icon" />}
                  iconRight={<FaLock />}
                  containerStyle={{
                    borderColor: !editMode
                      ? theme.colors.disable
                      : theme.colors.border,
                  }}
                />
              </FormContainer>
              <div className="btn-update">
                {editMode && (
                  <>
                    <Button
                      isLoading={loading}
                      variant="gray"
                      style={{ marginRight: '18px' }}
                      onClick={handleEdit}
                    >
                      Cancel
                    </Button>
                    <Button type="submit" isLoading={loading}>
                      Update
                    </Button>
                  </>
                )}
              </div>
            </Form>
          );
        }}
      </Formik>
    </PersonalInformationWrapper>
  );
};

export default PersonalInformation;
